import React, { useEffect, useState } from "react";
import { Star, Loader2, MessageSquareWarning } from "lucide-react";
import api from "@/lib/api";

const NAMES = { logo: "لوقو", business_card: "بطاقة عمل", image: "صورة", post_image: "منشور مصوّر", video: "فيديو", script_video: "فيديو بسيناريو", caption: "نص منشور", script: "سيناريو", strategy: "استراتيجية", campaign_post: "منشور حملة", brochure: "بروشور", menu: "منيو", flyer: "فلاير" };

/** تقييمات نتائج المنتجات: متوسط كل منتج + آخر التعليقات (المنخفضة أولًا). */
export const ProductRatingsAdmin = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/product-ratings").then((r) => setData(r.data)).catch(() => setData({ summary: [], items: [] })); }, []);
  if (!data) return <div className="glass rounded-2xl p-5 border border-border flex items-center gap-2 text-sm text-muted-foreground"><Loader2 className="w-4 h-4 animate-spin" /> تقييمات المنتجات…</div>;
  const low = data.items.filter((i) => i.rating <= 3);
  return (
    <div className="glass rounded-2xl p-5 border border-border" data-testid="product-ratings-admin">
      <div className="flex items-center gap-2 mb-3"><Star className="w-5 h-5 text-amber-400" /><h3 className="font-bold">تقييمات نتائج المنتجات</h3><span className="text-xs text-muted-foreground">({data.items.length})</span></div>
      {data.summary.length === 0 ? <p className="text-xs text-muted-foreground">لا تقييمات بعد — يظهر صف التقييم تحت كل نتيجة ينهيها العميل.</p> : (
        <div className="flex flex-wrap gap-2 mb-4">
          {data.summary.map((s) => (
            <div key={s.product} className="rounded-xl border border-border bg-secondary/50 px-3 py-2 text-xs" data-testid={`rating-summary-${s.product}`}>
              <div className="font-bold">{NAMES[s.product] || s.product}</div>
              <div className="flex items-center gap-1 mt-0.5"><Star className="w-3 h-3 fill-amber-400 text-amber-400" /><b>{s.average}</b><span className="text-muted-foreground">/5 · {s.count}</span>{s.low > 0 && <span className="text-rose-500">· {s.low} منخفض</span>}</div>
            </div>
          ))}
        </div>
      )}
      {low.length > 0 && (
        <div className="space-y-2">
          <div className="text-xs font-bold flex items-center gap-1 text-rose-500"><MessageSquareWarning className="w-3.5 h-3.5" /> عملاء غير راضين — تواصل معهم</div>
          {low.slice(0, 12).map((i) => (
            <div key={i.id} className="rounded-lg border border-rose-500/30 bg-rose-500/5 px-3 py-2 text-xs" data-testid={`low-rating-${i.id}`}>
              <div className="flex items-center gap-2 flex-wrap"><b>{NAMES[i.product] || i.product}</b><span className="text-amber-500">{"★".repeat(i.rating)}{"☆".repeat(5 - i.rating)}</span><span className="text-muted-foreground">{i.name} · {i.email}</span><span className="text-muted-foreground" dir="ltr">{(i.created_at || "").slice(0, 16).replace("T", " ")}</span></div>
              {i.comment && <p className="mt-1 text-foreground/90">{i.comment}</p>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
